<template>
    <div
        v-bind:class="{ _selected: selected }"
    >
        <span class="LeagueFilter-listItem-checkbox">
            <SvgIcon iconName="systemIcon_checked" />
        </span>
        {{ league.leagueName }}
    </div>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { defineComponent } from 'vue';
    import type { ILeague } from '@/interface/ILeagueMatchList';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'LeagueFilterDetail',
        components: {
            SvgIcon,
        },
        props: {
            league: {
                type: Object as PropType<ILeague>,
                required: true,
            },
            selected: {
                type: Boolean,
                default: false,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/leagueFilter";
</style>
